import { useMemo } from 'preact/hooks'
import { handleize } from 'helpers/utils'

function ProductCardSwatches({ position, options, variants, currentVariant, setCurrentVariant }) {
  const swatches = options[position].values

  if (!swatches) return

  const handleClick = (swatch) => {
    const selectedVariant = variants.find((variant) => handleize(variant.options[position]) === handleize(swatch))

    setCurrentVariant(selectedVariant)
  }

  const currentSwatch = useMemo(() => handleize(currentVariant.options[position]), [currentVariant])

  return (
    <div className="flex flex-wrap gap-1.5 h-fit">
      {swatches.map((swatch) => (
        <button
          type="button"
          title={swatch}
          onClick={() => handleClick(swatch)}
          className={` ${handleize(swatch)} ${currentSwatch === handleize(swatch) ? '!border-black' : 'border-transparent'} h-5 w-[22px] flex-none rounded border`}
        />
      ))}
    </div>
  )
}

export default ProductCardSwatches
